import { Box, tokens } from '@cast/design-system';

type Variant = 'predictive-scaling' | 'on' | 'off';

type WoopIndicatorProps = {
  disabled?: boolean;
  variant: Variant;
};

const getBgColor = (disabled: boolean, variant: Variant): string => {
  if (variant === 'predictive-scaling') {
    return disabled
      ? tokens.theme.bg.categorical.indigoSubtle
      : tokens.theme.bg.categorical.indigoStrong;
  }

  if (variant === 'on') {
    return disabled
      ? tokens.theme.bg.categorical.blueSubtle
      : tokens.theme.bg.selection.primary;
  }

  if (variant === 'off') {
    return disabled
      ? tokens.theme.bg.categorical.greySubtle
      : tokens.theme.bg.categorical.greyStrong;
  }

  return disabled
    ? tokens.theme.bg.categorical.greyStrong
    : tokens.theme.bg.selection.primary;
};

export const WoopIndicator = ({
  disabled = false,
  variant,
}: WoopIndicatorProps) => {
  return (
    <Box
      width={6}
      height={6}
      borderRadius="50%"
      bgcolor={getBgColor(disabled, variant)}
    />
  );
};
